/**
 * Created by Ning Jiang on 2021-05-04.
 */
import {OktoberfestParsedData} from "./OktoberfestParsedData";
import {IBetWinData, IOktoberfestGameData} from "./IOktoberfestData";
import {OktoberfestDataParser} from "./OktoberfestDataParser";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {OktoberfestGameConfig} from "../../OktoberfestGameConfig";
import {GameHelper} from "../../../core/utils/GameHelper";

export class OktoberfestParsedGameData extends OktoberfestParsedData {

    public readonly betWins: IBetWinData[];
    public readonly singleWin: number;
    public readonly playedBetValue: number;
    public readonly wasFeatureBuy: boolean;
    public readonly brokeTheBank: boolean;
    // Only sends in the last freespin.
    public readonly scatterPositionsEnteringFreespin: number[] | undefined;
    // Calculated values
    public readonly currentWinRatioConfig: IWinRatioConfig | null;
    // To add Spin Data
    public readonly nearWinReels: boolean[];
    public readonly nearWinBigWinReels: boolean[];
    // To add Nudge Data
    public readonly doReelNudge: boolean[];
    private readonly _stackedModeSymbol: string;
    private _overLayWilds: string[][];
    private _reels: string[][];
    public readonly isRestoreState: boolean;

    constructor(rawData: IOktoberfestGameData, parser: OktoberfestDataParser) {
        super(rawData, parser);

        this.isRestoreState = rawData.isRestoreState;
        this.betWins = parser.parseBetWins(rawData);
        this.singleWin = parseFloat(rawData.totalSpinWinnings);
        this.playedBetValue = parseFloat(rawData.playedBetValue);
        this.wasFeatureBuy = rawData.wasFeatureBuy;
        this.brokeTheBank = rawData.brokeTheBank;
        this.scatterPositionsEnteringFreespin = rawData.scatterPositionsEnteringFreespin;
        this._addedMultiplierThisSpin = rawData.addedMultiplierThisSpin;
        this._beerTokensCollectedThisSpin = rawData.beerTokensCollectedThisSpin;
        this._beerTokensCollectedInFreespin = rawData.beerTokenCollectedInFreespin;
        this._multiplierAfterSpin = rawData.multiplierAfterSpin;
        this._overLayWilds = rawData.overLayWilds;
        this._reels = GameHelper.getVisibleSymbolsFromReelsData(rawData.reels);
        // Calculated values.
        this.currentWinRatioConfig = parser.parseWinRatio(this.singleWin / this.playedBetValue);

        // To add Spin Data
        this.nearWinReels = rawData.nearWinReels == null ? ArrayHelper.initArrayWithValues(OktoberfestGameConfig.REELS_NUM, () => false) : rawData.nearWinReels.concat();
        this.nearWinBigWinReels = rawData.nearWinBigWinReels == null ? ArrayHelper.initArrayWithValues(OktoberfestGameConfig.REELS_NUM, () => false) : rawData.nearWinBigWinReels.concat();

        // To add Nudge Data
        this.doReelNudge = rawData.doReelNudge?.concat();
        this._stackedModeSymbol = rawData.stackedModeSymbol;
    }

    private _beerTokensCollectedInFreespin: number;

    get beerTokensCollectedInFreespin(): number {
        return this._beerTokensCollectedInFreespin;
    }

    private _beerTokensCollectedThisSpin: number;

    get beerTokensCollectedThisSpin(): number {
        return this._beerTokensCollectedThisSpin;
    }

    get stackedModeSymbol(): string {
        return this._stackedModeSymbol;
    }

    get overlayWilds(): string[][] {
        return this._overLayWilds;
    }

    get reelData(): string[][] {
        return this._reels;
    }

    // To add gamble Data:
    // public readonly gambleCollect:boolean;
    // public readonly gambleOptions:any;
    // public readonly gambleSuccess:boolean;

    // To add Avalanche Data:
    // public readonly newSymbols:string[][];
    // public readonly nearWinPositions:boolean[][];

    private _addedMultiplierThisSpin: number;

    get addedMultiplierThisSpin(): number {
        return this._addedMultiplierThisSpin;
    }

    private _multiplierBeforeSpin: number;

    get multiplierBeforeSpin(): number {
        return this._multiplierBeforeSpin;
    }

    private _multiplierAfterSpin: number;

    get multiplierAfterSpin(): number {
        return this._multiplierAfterSpin;
    }

    protected parseScatterPositions(rawData: IOktoberfestGameData): number[] | undefined {
        return rawData.scatterPositions ? rawData.scatterPositions : ArrayHelper.initArrayWithValues(OktoberfestGameConfig.REELS_NUM, reelId => -1);
    }

}
